import { Controller } from "@hotwired/stimulus";

const TIMING_MODES = new Set([ "", "recurring", "one_time" ]);

export default class extends Controller {
  static targets = [
    "select",
    "recurringFields",
    "oneTimeFields",
    "detailField",
    "clearField",
    "recursAnnuallyField",
    "dateSpecificField"
  ];

  connect() {
    this.sync(this.selectTarget.value, { clearDetails: false });
  }

  change(event) {
    if (event.target !== this.selectTarget) return;

    this.sync(event.target.value, { clearDetails: true });
  }

  sync(rawMode, { clearDetails }) {
    const mode = TIMING_MODES.has(rawMode) ? rawMode : "";

    if (clearDetails) {
      this.detailFieldTargets.forEach((field) => {
        field.value = "";
      });
    }

    this.setSection(this.recurringFieldsTarget, mode === "recurring");
    this.setSection(this.oneTimeFieldsTarget, mode === "one_time");

    this.detailFieldTargets.forEach((field) => {
      const active = field.dataset.occasionTimingMode === mode;
      field.disabled = !active;
      field.required = active;
    });

    this.clearFieldTargets.forEach((field) => {
      field.disabled = field.dataset.occasionTimingMode === mode;
    });

    this.recursAnnuallyFieldTargets.forEach((field) => {
      field.value = mode === "recurring" ? "true" : "false";
    });

    this.dateSpecificFieldTargets.forEach((field) => {
      field.value = mode === "one_time" ? "true" : "false";
    });
  }

  setSection(section, visible) {
    section.hidden = !visible;
    section.setAttribute("aria-hidden", String(!visible));
  }
}
